<script>
	import { fly, fade } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';
	import FormText from '$lib/components/Form-Text.svelte';
	import FormNumber from '$lib/components/Form-Number.svelte';
	import FormSelect from '$lib/components/Form-Select.svelte';
	import FormMessage from '$lib/components/Form-Mesage.svelte';
	import { browser, building, dev, version } from '$app/environment';
	import { goto } from '$app/navigation';
	let date = 'October 20th, 2024';

	let firstName = '';
	let firstNameInValid = true;
	let lastName = '';
	let lastNameInValid = true;
	let email = '';
	let emailInvalid = true;
	let groupSize = '';
	let groupSizeInvalid = true;
	let vegetarians = 0;
	let vegetariansInvalid = false;
	let refferer = '';
	let reffererInvalid = true;
	let dineIn = '';
	let dineInInvalid = true;
	let message = '';
	let messageInvalid = false;
	let development = dev;

	let sending = false;
	let success = true;
	let confirmation = false;
	let error = false;
	$: invalid =
		messageInvalid ||
		dineInInvalid ||
		reffererInvalid ||
		vegetariansInvalid ||
		groupSizeInvalid ||
		lastNameInValid ||
		emailInvalid ||
		firstNameInValid;

	let submit = async () => {
		sending = true;
		error = false;
		if (invalid) {
			sending = false;
			return;
		}
		let body = {
			firstName,
			lastName,
			email,
			groupSize,
			vegetarians,
			refferer,
			dineIn,
			message,
			development
		};
		fetch('/api/rsvp', {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Accept: 'application/json'
			}
		}).then(async (res) => {
			console.log(res);
			if (res.ok) {
				let json = await res.json();
				console.log(json);
				if (json.res.acknowledged) {
					confirmation = json.confirmationNumber;
					goto('/rsvp/success/' + confirmation);
					error = false;
					success = true;
				}
				sending = false;
			} else {
				sending = false;
				error = res.statusText;
				let { message } = await res.json();
				if (message) {
					error = res.statusText + ' ' + message;
				}
			}
		});
	};
	const errorTransition = { y: -5, duration: 50, easing: cubicOut, delay: 0 };
</script>

<svelte:head>
	<title>RSVP | Jordanian Food for Funds Pop Up Dinner</title>
	<meta
		name="description"
		content={`RSVP for the Jordanian Food for Funds Pop up Dinner on ${date}`}
	/>
</svelte:head>
<main>
	<div transition:fly={{ y: -10, duration: 200, easing: cubicOut, delay: 0 }}>
		<header>
			<h1 class="secondary_heading">Jordanian Food for Funds Dinner – RSVP</h1>
			<h2 class="tertiary_heading">{date} at the Common Roots Homestead</h2>

			<p class="text-block">
				Thank you for your interest in our pop-up dinner. We have a few questions to make sure we
				can accomodate you. Please note that the event is on a first come first serve basis.
			</p>
			<br />
			<p class="text-block">Vegetarians will be served a larger portion of lentil soup.</p>
			<br />
			<p>If you've already RSVPed and need to make a change:</p>
			<a href="/rsvp/manage">Update your existing RSVP</a>
		</header>

		<form on:submit|preventDefault={submit}>
			<div class="form-row">
				<FormText
					label="First Name"
					auto="given-name"
					formId="firstName"
					required="true"
					bind:value={firstName}
					disabled={sending}
					bind:invalid={firstNameInValid}
				/>
				<FormText
					label="Last Name"
					auto="family-name"
					formId="lastName"
					required="true"
					bind:value={lastName}
					disabled={sending}
					bind:invalid={lastNameInValid}
				/>
			</div>
			<FormText
				label="Email"
				auto="email"
				formId="email"
				type="email"
				required="true"
				bind:value={email}
				disabled={sending}
				bind:invalid={emailInvalid}
			/>
			<div class="form-row">
				<FormNumber
					formId="groupSize"
					label="Group Size"
					required="true"
					bind:value={groupSize}
					disabled={sending}
					bind:invalid={groupSizeInvalid}
					min={1}
				/>
				<FormNumber
					formId="vegetarians"
					label="Vegetarians"
					bind:value={vegetarians}
					disabled={sending}
					bind:invalid={vegetariansInvalid}
					required={true}
					max={groupSize}
					maxReason="group size"
				/>
				<FormSelect
					formId="dineIn"
					label="Dine In or Take Out?"
					required="true"
					options={[
						{ label: 'dine in', val: 'in' },
						{ label: 'take out', val: 'out' }
					]}
					bind:value={dineIn}
					disabled={sending}
					bind:invalid={dineInInvalid}
				/>
			</div>
			<FormSelect
				formId="refferer"
				label="How did you hear about us?"
				required="true"
				options={[
					{ label: 'posters', val: 'posters' },
					{ label: 'word of mouth', val: 'word-of-mouth' },
					{ label: 'food sample table', val: 'sample-table' },
					{ label: 'an organizer', val: 'organizer' },
					{ label: 'email list', val: 'email-list' },
					{ label: 'other', val: 'other' }
				]}
				bind:value={refferer}
				disabled={sending}
				bind:invalid={reffererInvalid}
			/>
			<FormMessage
				formId="message"
				label="Any Notes to Add?"
				bind:value={message}
				disabled={sending}
			/>
			<div class="details">
				<p class="text-block">
					Because of our limited menu, we are unable to accomodate dietary restrictions.
				</p>
				<p class="text-block">
					Please note that your photo may be taken for promotional purposes. <br /> If you have a concern
					with this please write us a note above.
				</p>
				<p class="text-block">You will recieve a confirmation as the event draws near.</p>
				<p class="text-block"><b>$25 suggested donation - cash or venmo.</b></p>
			</div>
			{#if error}
				<p transition:fly={errorTransition} class="form-error">error submitting form: {error}</p>
			{/if}
			<button class="btn" type="submit" disabled={sending}
				>{sending ? 'submitting...' : 'submit'}</button
			>
		</form>
	</div>

	<enhanced:img
		class="banner"
		src="$lib/images/webp/dinner-banner.webp"
		alt="happy dinners at Jordanian Food for funds event eating in the rustic dining room."
	>
	</enhanced:img>
</main>

<style>
	main {
		width: 100%;
	}
	header {
		width: 100%;
	}
	.banner {
		width: 100%;
		height: auto;
		margin-top: 4em;
	}
	.form-row {
		display: flex;
	}

	form {
		max-width: 1000px;
		margin-top: 2em;
	}
	form .btn {
		margin-top: 2em;
	}
	form .text-block {
		margin: 0.75em 0;
	}
	.details {
		margin-top: 2em;
	}
	h2 {
		margin-bottom: 1em;
	}
	.successContainer {
		min-height: 60vh;
	}

	@media only screen and (max-width: 1400px) {
		main {
			width: auto;
		}
	}
	@media only screen and (max-width: 700px) {
		.form-row {
			display: block;
		}
	}
</style>
